import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ScrollTop = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setShow(window.scrollY > 400);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo(0, 0);
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      className={`scroll-top ${show ? 'is-visible' : ''}`}
      onClick={handleClick}
      aria-label={t('scrollTop.ariaLabel')}
    >
      <i className="fas fa-chevron-up" aria-hidden="true"></i>
    </button>
  );
};

export default ScrollTop;